import type { ReactElement } from "react"
import { useState } from "react"

import { useTranslation } from "react-i18next"

import AutoGraphIcon from "@mui/icons-material/AutoGraph"
import BoltIcon from "@mui/icons-material/Bolt"
import { Grid } from "@mui/material"
import { Tab, Tabs } from "@synapse-analytics/synapse-ui"

import { Decisions } from "../features/Decisions/components/Decisions/Decisions"
import { RealTimeInsights } from "../features/Insights"

export function LiveDecision(): ReactElement {
  const [tab, setTab] = useState<"decisions" | "insights">("insights")

  const { t } = useTranslation("decisions", {
    keyPrefix: "liveDecisions",
  })

  return (
    <Grid container gap={2}>
      <Tabs value={tab}>
        <Tab
          icon={() => <AutoGraphIcon fontSize="small" />}
          label={t("tabs.insights")}
          value="insights"
          selected={tab === "insights"}
          onClick={() => setTab("insights")}
          size="large"
        />
        <Tab
          icon={() => <BoltIcon fontSize="small" />}
          label={t("tabs.decisions")}
          value="decisions"
          selected={tab === "decisions"}
          onClick={() => setTab("decisions")}
          size="large"
        />
      </Tabs>

      {tab === "decisions" ? <Decisions /> : <RealTimeInsights />}
    </Grid>
  )
}
